import { createSlice } from "@reduxjs/toolkit";
import { getRequest, postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";

const initialState = {
  bannersData: "",
  superBannersData: "",
};

export const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    setBannersData: (state, action) => {
      state.bannersData = action.payload;
    },
    setSuperBannersData: (state, action) => {
      state.superBannersData = action.payload;
    },
  },
});

export const { setBannersData } = bannersSlice.actions;
export const { setSuperBannersData } = bannersSlice.actions;

export default bannersSlice.reducer;

export const fetchBanners = () => (dispatch) => {
  let url = endpoints.banners;
  let superBannerUrl = endpoints.cms_endpoint;
  getRequest(superBannerUrl).then((res) => {
    if (res?.status === 200) {
      dispatch(setBannersData(res?.data));
      dispatch(setSuperBannersData(res?.data));
    } else {
      dispatch(setBannersData([]));
      dispatch(setSuperBannersData([]));
    }
  });
};
